/**
 * Plazo de devolucion. El mismo numero sale impreso en el pie legal del ticket
 * (TicketPrintService) y corta las devoluciones fuera de plazo, para que no
 * puedan decir cosas distintas.
 */
export const DIAS_DEVOLUCION = 15;

export const AVISO_PLAZO_TICKET =
    `*No se admitirán cambios ni devoluciones transcurridos ${DIAS_DEVOLUCION} días desde la fecha de compra, excepto productos defectuosos.`;

/** Medianoche local de una fecha, para contar dias de calendario y no horas. */
const aMedianoche = (d: Date): number =>
    new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();

/**
 * Dias de calendario transcurridos desde la compra.
 *
 * Se cuenta por fechas, no por horas: una compra de las 19:00 del dia 1 aguanta
 * hasta el final del dia 16, no hasta las 19:00. Es lo que entiende el cajero
 * por "15 dias desde la fecha de compra", y evita que un ticket se caiga por
 * unas horas. El redondeo absorbe los dias de 23 y 25 horas del cambio de hora.
 */
export const diasDesdeLaCompra = (compra: Date): number =>
    Math.round((aMedianoche(new Date()) - aMedianoche(compra)) / 86400000);

export const fueraDePlazo = (compra: Date): boolean =>
    diasDesdeLaCompra(compra) > DIAS_DEVOLUCION;

/** Mensaje unico para las dos puertas de entrada a la devolucion. */
export const mensajeFueraDePlazo = (ticketNumber: string, compra: Date): string =>
    `El ticket ${ticketNumber} es del ${compra.toLocaleDateString('es-ES')}, hace ${diasDesdeLaCompra(compra)} días. ` +
    `El plazo de devolución es de ${DIAS_DEVOLUCION} días.`;
